var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHmArc4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 252.447,
    height: 81.4598,
    viewBox: "0 0 252.447 81.4598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2116",
    d: "M-7.80702e-07 1.28999C12.1603 22.8664 29.2377 41.2708 49.8454 55.0089C70.4531 68.7469 94.0103 77.4314 118.604 80.357C143.198 83.2827 168.135 80.3671 191.39 71.8469C214.646 63.3268 235.564 49.4423 252.447 31.3209L250.525 29.5299C233.924 47.3491 213.354 61.0019 190.487 69.3799C167.619 77.758 143.098 80.6249 118.914 77.7481C94.7309 74.8713 71.5667 66.3317 51.3028 52.8228C31.0388 39.3139 14.2463 21.2164 2.28885 4.62027e-06L-7.80702e-07 1.28999Z",
    fill: "#FFE743"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmArc4);
export default __webpack_public_path__ + "static/media/hmArc4.7dd273243593ff70715b397273c1815c.svg";
export { ForwardRef as ReactComponent };